import Image from "../Image/Image";
import { Link } from "react-router-dom";
import hos_elevance_health from "../../assets/Images/hos_elevance_health.png";
import { BASE_NAME, NAVIGATE_TO, TEXTS } from "../../constants/FileConstants";
import {
  AppBar,
  Toolbar,
  Button,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "./Header.css";
import React from "react";
import "./Header.scss";
import { ExtractBaseURL } from "../ExtractBaseURL/ExtractBaseURL";

const Header = () => {
  // Dynamic logo selection based on domain
  const currentHostname = window.location.hostname;
  const isCarelonDomain = currentHostname.includes('carelon.com');
  
  const logoUrl = isCarelonDomain
    ? "https://www.carelon.com/content/dam/digital/carelon/logos/crl_sm_h_rgb_cN.svg"
    : "https://www.elevancehealth.com/content/dam/elevance-health-non-index/logos/Apex-Header.svg";

    const logoStyle = isCarelonDomain
    ? { height: '2.5rem', width: 'auto', marginLeft: '5px', marginRight: '20px' }
    : {};

  return (
    <nav id="navigation-bar">
      <a href={ExtractBaseURL() + BASE_NAME + NAVIGATE_TO.DOCUMENTATION} id="logo-container">
        <img src={logoUrl} alt={isCarelonDomain ? "Carelon" : "Elevance Health"} style={logoStyle} />
      </a>
      <div className="nav-right">
        <h3>FHIR API Documentation</h3>

        <div className="nav-link">
          {/* <Link to={NAVIGATE_TO.DOCUMENTATION}>
            Documentation
          </Link> */}
          {/* <Link to={NAVIGATE_TO.CONTACT}>
            Contact
          </Link> */}
          <TextField
            placeholder="Search"
            InputProps={{
              endAdornment: <SearchIcon />,
            }}
          />
        </div>
      </div>
    </nav>
  );
};

export default Header;
